import { Layout } from '@kanda-libs/ks-design-library';

import ExampleJobAlertBanner from 'components/ExampleJobAlertBanner';
import useHelpModal from 'components/HelpModal/useHelpModal';

import Header from './Header';

import Footer from '../Footer';

interface MobileProps {
  children: JSX.Element;
  showOuterLayout?: boolean;
  nextButtonProps?: {
    disabled?: boolean;
  };
  isSubmitting?: boolean;
}

const Mobile: React.FunctionComponent<MobileProps> = function ({
  children,
  showOuterLayout,
  nextButtonProps,
  isSubmitting,
}) {
  const { showHelpModal } = useHelpModal();
  return (
    <Layout
      header={<Header help={showHelpModal} showSteps={showOuterLayout} />}
      footer={
        <Footer
          showNextButton={showOuterLayout}
          nextButtonProps={nextButtonProps}
          isSubmitting={isSubmitting}
        />
      }
    >
      <div className="flex flex-col mx-auto max-w-100">
        <ExampleJobAlertBanner />
        {children}
      </div>
    </Layout>
  );
};

export default Mobile;
